import React from "react";

function Footer() {
  return (
    <footer className="footer">
      © 2026 Vidhya Boutique | Designed with ❤️
    </footer>
  );
}

export default Footer;
